import React, { useEffect, useCallback } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Page, Header } from 'components';

import BwUpdateForm from './components/BwUpdateForm.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const BwUpdate = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	return (
		<Page className={classes.root} title="Scripts">
			<Header module="Scripts" view="Bandwidth Update" />
			<div className={clsx(classes.container)}>
				<BwUpdateForm />
			</div>
		</Page>
	);
};

export default BwUpdate;
